import React, { forwardRef, ReactNode } from "react";
import SoftTypographyRoot from "./SoftTypographyRoot";
import { SxProps, Theme } from "@mui/material/styles";

type SoftTypographyColor =
  | "inherit"
  | "primary"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "light"
  | "dark"
  | "text"
  | "white";

type FontWeight = false | "light" | "regular" | "medium" | "bold";
type TextTransform = "none" | "capitalize" | "uppercase" | "lowercase";
type VerticalAlign =
  | "unset"
  | "baseline"
  | "sub"
  | "super"
  | "text-top"
  | "text-bottom"
  | "middle"
  | "top"
  | "bottom";

interface SoftTypographyProps extends React.HTMLAttributes<HTMLElement> {
  color?: SoftTypographyColor;
  fontWeight?: FontWeight;
  textTransform?: TextTransform;
  verticalAlign?: VerticalAlign;
  textGradient?: boolean;
  opacity?: number;
  children: ReactNode;
  variant?: TypographyVariant;
  sx?: SxProps<Theme>;
}
type TypographyVariant =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "subtitle1"
  | "subtitle2"
  | "body1"
  | "body2"
  | "button"
  | "caption"
  | "overline";
const SoftTypography = forwardRef<HTMLElement, SoftTypographyProps>(
  (
    {
      color = "dark",
      fontWeight = false,
      textTransform = "none",
      verticalAlign = "unset",
      textGradient = false,
      opacity = 1,
      children,
      ...rest
    },
    ref
  ) => (
    <SoftTypographyRoot
      {...rest}
      ref={ref}
      ownerState={{
        color,
        textTransform,
        verticalAlign,
        fontWeight,
        opacity,
        textGradient,
      }}
    >
      {children}
    </SoftTypographyRoot>
  )
);

SoftTypography.displayName = "SoftTypography";

export default SoftTypography;
